ele.mouse = (function(){

	return {
		preventDoubleClick: function(selectorList){
            $(selectorList).on("click", function() {
                let $button = $(this);
                let href = $button.attr("href");

                setTimeout(function () {
                    $button.prop("disabled", true);
                    $button.attr("href", "javascript:void(0);");
                    $button.css({
                        opacity: .8,
                        cursor: "wait"
                    });
                }, 2);

                setTimeout(function () {
                    $button.prop("disabled", false);
                    $button.attr("href", href);
                    $button.css({
                        opacity: 1,
                        cursor: "default"
                    });
                }, 6000);

            });
		},

        preventDoubleClickWithValidation: function(selectorList){
            let $button = $(selectorList);
            let href = $button.attr("href");

            $button.prop("disabled", true);
            $button.attr("href", "javascript:void(0);");
            $button.css({
                opacity: .8,
                cursor: "wait"
            });

            setTimeout(function () {
                $button.prop("disabled", false);
                $button.attr("href", href);
                $button.css({
                    opacity: 1,
                    cursor: "default"
                });
            }, 6000);
        }
	}
})();

//.e_document_launch - either starts trial, starts EVM process or goes straight through free checkout. Causing db smuch and unnecessary additional processing

$(function () {
    ele.mouse.preventDoubleClick(".e_document_launch");
});
